import { render } from "./SpeakerProfile.vue?vue&type=template&id=5df04ba8&scoped=true"
import script from "./SpeakerProfile.vue?vue&type=script&lang=js"
export * from "./SpeakerProfile.vue?vue&type=script&lang=js"

import "./SpeakerProfile.vue?vue&type=style&index=0&id=5df04ba8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df04ba8"]])

export default __exports__